import { DisplayMethod } from '@/types'

export interface BibliographyAloneSearchTooliRequest {
  displayMethod: DisplayMethod
  newPublicationInformationVolume: string | undefined
  isbn: string | undefined
  marcType: string | undefined
  marcNo: string | undefined
}

export function BibliographyAloneSearchTooliRequestToJSON(
  value: BibliographyAloneSearchTooliRequest
): any {
  return {
    display_method: value.displayMethod ?? undefined,
    new_publication_information_volume:
      value.newPublicationInformationVolume !== ''
        ? value.newPublicationInformationVolume
        : undefined,
    isbn: value.isbn !== '' ? value.isbn : undefined,
    marc_type: value.marcType !== '' ? value.marcType : undefined,
    marc_no: value.marcNo !== '' ? value.marcNo : undefined
  }
}
